export const getPageCount = (total: number | undefined, limit: number) => (
  total === undefined ? 0 : Math.ceil(total / limit)
);

export const getDateStringForTableCell = (date: Date | null): string => (
  date?.toDateString().substring(4) ?? ''
);

export const DEFAULT_PAGE_SIZE = 20;
